import React from "react";
import { FileText } from "lucide-react";
import { Skeleton } from "../ui/LoadingStates";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function PayslipCard({ payslips = [], selectedYear, onSelect, loading }) {
  const years = [...new Set(payslips.map(p => p.financialYear))].sort().reverse();
  const filtered = payslips.filter(p => p.financialYear === selectedYear);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">My Payslips</span>
        {years.length > 0 && (
          <select
            value={selectedYear}
            onChange={e => onSelect(null, e.target.value)}
            className="bg-black border border-[#00ff90]/20 rounded-lg px-3 py-1 text-xs text-white outline-none focus:border-[#00ff90]/50 transition-colors"
          >
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        )}
      </div>

      <div className="p-4 space-y-2">
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="rounded-lg border border-white/5 bg-white/3 px-4 py-2.5"
                 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Skeleton width={14} height={14} radius={3} />
                <Skeleton width={80} height={10} />
              </div>
              <Skeleton width={50} height={20} radius={6} />
            </div>
          ))
        ) : filtered.length === 0 ? (
          <p className="text-white/20 text-sm italic py-4 text-center">No payslips available.</p>
        ) : (
          filtered.map(p => (
            <div key={p.id} className="flex items-center justify-between gap-3 rounded-lg border border-white/5 bg-white/3 px-4 py-2.5">
              <div className="flex items-center gap-2">
                <FileText size={14} className="text-[#00ff90]/40 shrink-0" />
                <span className="text-sm text-white/70">{p.month}</span>
                {p.netPay && <span className="text-xs text-white/30">· {typeof p.netPay === "number" ? `£${p.netPay.toLocaleString()}` : p.netPay}</span>}
              </div>
              <button
                onClick={() => onSelect(p.id)}
                className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors"
              >
                View
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}